import React, { Component } from "react";
import { densitiesList } from "../../../../settings";

export default class RoomRugFilterMobileDensities extends Component {
  handleManualScroll = (direction) => {
    switch (direction) {
      case "right":
        document.getElementById("ulSlider").scrollLeft -= 120;
        break;
      default:
        document.getElementById("ulSlider").scrollLeft += 120;
        break;
    }
  };
  render() {
    return (
      <ul id="three-child-body" className="three-child-body active">
        {densitiesList.map((density) => (
          <li
            className={
              this.props.selectedDensities.indexOf(density) >= 0 ? "three-child active" : "three-child"
            }
            key={"filterDensityMobile" + density}
            onClick={() =>
              this.props.selectHandler(density, this.props.activeFilter)
            }
          >
            <span>{density}</span>
          </li>
        ))}
      </ul>
    );
  }
}
